module.exports = __webpack_public_path__ + "images/50ddec9467508d5cce3c31f0ff5a64bbf5ac5329a732e926d7b87c1acea4da5c.svg";